import React, {Component} from 'react';
import {gpn} from "../GPN"
import config from "../config";
import axios from "axios";
import Field from "../sections/MUI/Field";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";

class Login extends Component {

    state = {
        phoneNumber: "",
        verificationCode: "",

        step: 1
    };

    componentDidMount() {
        if (config.token !== "") {
            this.getInfo();
        } else {
            this.checkInit();
        }
    }

    checkInit() {
        axios.get(`${config.api}/admin/init/check`)
            .then(r => {
                if (!r.data.status) {
                    document.location.href = "/init"
                }
            })
            .catch(err => {
            });
    }

    getInfo() {
        axios.get(`${config.api}/admin/info?token=${config.token}`)
            .then(r => {
                document.location.href = "/";
            })
            .catch(err => {

            });
    }

    sendCode() {
        const {phoneNumber} = this.state;
        toast.info("در حال ارسال کد ...")
        if (phoneNumber.length === 11) {
            let params = new URLSearchParams();
            params.append("phoneNumber", phoneNumber);
            axios.post(`${config.api}/admin/login/code`, params)
                .then(r => {
                    toast.success("کد تایید با موفقیت ارسال شد ...")
                    this.setState({step: 2})
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("فرمت شماره موبایل نامعتبر است!")
        }
    }

    verify() {
        const {phoneNumber, verificationCode} = this.state;
        if (verificationCode.length >= 5) {
            let params = new URLSearchParams();
            params.append("phoneNumber", phoneNumber);
            params.append("verificationCode", verificationCode);

            axios.post(`${config.api}/admin/login/verify`, params)
                .then(r => {
                    let token = r.data.result.token;
                    localStorage.setItem("token", token);
                    toast.success("خوش آمدید ...");
                    setTimeout(()=>{
                        document.location.href = "/"
                    }, 2000)
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("کد تایید به درستی وارد نشده!")
        }
    }

    render() {
        const {phoneNumber, verificationCode, step} = this.state;
        return (
            <div className="login">
                <div className="card">
                    {step === 1 ?
                        <>
                            <Field name="phoneNumber"
                                   value={phoneNumber}
                                   label="شماره موبایل"
                                   maxLength={13}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <div className="row justify-content-center">
                                <div className="col-md-5">
                                    <Button submit={false} icon="check"
                                            onClick={() => this.sendCode()}>ارسال کد</Button>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <Field name="verificationCode"
                                   value={verificationCode}
                                   label="کد تایید"
                                   maxLength={7}
                                   type="number"
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <div className="row justify-content-center">
                                <div className="col-md-5">
                                    <Button submit={false} icon="check"
                                            onClick={() => this.verify()}>ورود</Button>
                                </div>
                            </div>
                        </>}
                </div>
            </div>
        );
    }
}

export default gpn(Login);